import { FormControlLabel, Checkbox } from '@mui/material';
import React from 'react';
export interface Tag {
  label: string;
  value: string;
}
interface SearchTagProps {
  option: Tag;
  checked: boolean;
  handleChange: (tag: Tag) => void;
}

const StyleCheckbox: React.FC<SearchTagProps> = ({ option, checked, handleChange }) => {
  const { label, value } = option;
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} size='small' />}
      label={label}
      labelPlacement='end'
      slotProps={{
        typography: {
          fontSize: '12px',
        },
      }}
      onChange={() => {
        handleChange({ label, value });
      }}
    />
  );
};
export default StyleCheckbox;
